import { HugeiconsIcon } from "@hugeicons/react";
import { PlusSignIcon } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import { useDebounce } from "@/hooks/useDebounce";
import {
  CustomAddressDrawer,
  CustomAddressTable,
  useCustomAddressList,
  useCustomAddressStore,
} from "@/features/customAddress";

export default function CustomAddressesPage() {
  const openDrawerForAdd = useCustomAddressStore((s) => s.openDrawerForAdd);
  const keyword = useCustomAddressStore((s) => s.keyword);
  const debouncedKeyword = useDebounce(keyword, 300);
  const { data, isLoading, error } = useCustomAddressList(debouncedKeyword);

  return (
    <div className="flex h-full flex-col bg-slate-50/50 p-4">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900">보완 주소 관리</h1>
          <p className="mt-0.5 text-xs text-gray-600">
            주소 검색에 없는 신설 공단·농장·미등재 도로명 등을 전사 공용으로 등록해 검색 결과에 병합합니다
          </p>
        </div>
        <Button
          size="sm"
          onClick={openDrawerForAdd}
          className="bg-blue-600 px-3 py-1.5 text-sm font-bold hover:bg-blue-700"
        >
          <HugeiconsIcon icon={PlusSignIcon} size={14} className="mr-1.5" />
          신규 등록
        </Button>
      </div>

      <CustomAddressTable data={data} isLoading={isLoading} error={error} />

      <CustomAddressDrawer />
    </div>
  );
}
